import { render, staticRenderFns } from "./Ver2DMS.vue?vue&type=template&id=0aede872"
import script from "./Ver2DMS.vue?vue&type=script&lang=js"
export * from "./Ver2DMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports